import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { partnerReligionSocialPreferenceEditSchema } from '../../../ValidationSchema';
import { toast } from 'react-toastify';
import { editpartnerReligioussocialPreference, getAllPhysicalStatus, getCast, getCasteByIds, getDomain, getReligion, getReligionByIds } from '../../../../asiosConfig';
import { Autocomplete, Button, Card, CardContent, CardHeader, Chip, MenuItem, TextField } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const PartnerReligionEthnicityEdit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userProfileData = location.state?.userProfileData || {};
  const [domains, setDomains] = useState([]);
  const [religions, setReligions] = useState([]);
  const [communities, setCommunities] = useState([]);
  const [languages, setLanguages] = useState([]);

  const domainArray = userProfileData.partnerDomainId
    ? userProfileData.partnerDomainId.split(',').map((item) => item.trim())
    : [];
  const religionArray = userProfileData.partnerReligionids
    ? userProfileData.partnerReligionids.split(',').map((item) => item.trim())
    : [];


  const formik = useFormik({
    initialValues: {
      partnerDomain: domainArray || [], // Multi-selection
      partnerReligion: religionArray || [], // Multi-selection
      partnerCaste: userProfileData.partnercastIds ? userProfileData.partnercastIds.split(',').map((item) => item.trim()) : [], // Multi-selection
      What_I_am_Looking_For: userProfileData.aboutLifePartner || '',
      partnerSevvaiDosham: userProfileData.partnerSevvaiDosham || '',
      partnerMotherTongue: userProfileData.partnerMotherTongue ? userProfileData.partnerMotherTongue.split(',').map((item) => item.trim()) : [] || '', // Multi-selection
      // token: localStorage.getItem('token')
    },
    validationSchema: partnerReligionSocialPreferenceEditSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const formattedValues = {
          ...values,
          partnerReligion: values.partnerReligion.join(','), // Convert back to string
          partnerCaste: values.partnerCaste.join(','), // Convert back to string
          partnerDomain: values.partnerDomain.join(','), // Convert back to string
          partnerMotherTongue: values.partnerMotherTongue.join(','), // Convert back to
        };
        const response = await editpartnerReligioussocialPreference(formattedValues);
        if (response.status === 200 || response.status === 201) {
          toast.success(response.data.message);
          setTimeout(() => {
            navigate(-1);
          }, 3000);
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [domainRes, languageRes] = await Promise.all([
          getDomain(),
          getAllPhysicalStatus(),
        ]);
        setDomains(domainRes.data.data);
        setLanguages(languageRes.data.data.get_language);
        if (formik.values.partnerDomain.length > 0) {
          const religionRes = await getReligionByIds({ ids: formik.values.partnerDomain });
          setReligions(religionRes.data);

          if (formik.values.partnerReligion.length > 0) {
            const casteRes = await getCasteByIds({ ids: formik.values.partnerReligion });
            setCommunities(casteRes.data);
          }
        }
      } catch (error) {
        toast.error(error.message);
      }
    };
    fetchInitialData();
  }, []);

  // Handle domain changes
  useEffect(() => {
    const handleDomainChange = async () => {
      if (formik.values.partnerDomain.length === 0) {
        setReligions([]);
        setCommunities([]);
        formik.setFieldValue('partnerReligion', []);
        formik.setFieldValue('partnerCaste', []);
        return;
      }

      try {
        const response = await getReligionByIds({ ids: formik.values.partnerDomain });
        setReligions(response.data);

        // Reset religion and caste if new domains don't include the previous religion
        const currentReligions = response.data.map(r => String(r.id));
        const filteredReligions = formik.values.partnerReligion.filter(r =>
          currentReligions.includes(r)
        );

        if (filteredReligions.length !== formik.values.partnerReligion.length) {
          formik.setFieldValue('partnerReligion', filteredReligions);
          formik.setFieldValue('partnerCaste', []);
          setCommunities([]);
        }
      } catch (error) {
        toast.error(error.message);
      }
    };

    handleDomainChange();
  }, [formik.values.partnerDomain]);

  // Handle religion changes
  useEffect(() => {
    const handleReligionChange = async () => {
      if (formik.values.partnerReligion.length === 0) {
        setCommunities([]);
        formik.setFieldValue('partnerCaste', []);
        return;
      }

      try {
        const response = await getCasteByIds({ ids: formik.values.partnerReligion });
        setCommunities(response.data);

        // Reset caste if new religions don't include the previous caste
        const currentCastes = response.data.flatMap(rel =>
          rel.castes.map(c => String(c.id))
        );
        const filteredCastes = formik.values.partnerCaste.filter(c =>
          currentCastes.includes(c)
        );

        if (filteredCastes.length !== formik.values.partnerCaste.length) {
          formik.setFieldValue('partnerCaste', filteredCastes);
        }
      } catch (error) {
        toast.error(error.message);
      }
    };

    handleReligionChange();
  }, [formik.values.partnerReligion]);

  return (
    <div className="col-lg-9 col-12">
      <Card className="editProfileBlock">
        <CardHeader
          avatar={<ArrowBackIcon sx={{ color: '#FF8008' }} onClick={() => navigate(-1)} />}
          title="Partner's Religion Kundli and Astro"
          subheader="Update your partner's religion kundali and Astro details to find suitable matches"
          titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }}
        />
        <CardContent>
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <Autocomplete
                  multiple
                  options={domains}
                  getOptionLabel={(option) => option.domain}
                  value={domains.filter(rel => formik.values.partnerDomain.includes(String(rel.id)))}
                  onChange={(event, newValue) => {
                    formik.setFieldValue('partnerDomain', newValue.map(item => String(item.id)));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Partner Domain"
                      variant="outlined"
                      className='mb-3'
                      error={formik.touched.partnerDomain && Boolean(formik.errors.partnerDomain)}
                      helperText={formik.touched.partnerDomain && formik.errors.partnerDomain}
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={option?.domain || ''} // Safeguard against undefined option
                        onDelete={() =>
                          formik.setFieldValue('partnerDomain', formik.values.partnerDomain.filter(id => id !== String(option.id)))
                        }
                        {...getTagProps({ index })}
                        key={option.id}
                      />
                    ))
                  }
                />

              </div>

              <div className="col-md-6">
                <Autocomplete
                  multiple
                  options={religions}
                  getOptionLabel={(option) => `${option.religion} {${option.domain}}`}  // Add domain in braces
                  value={religions.filter(rel => formik.values.partnerReligion.includes(String(rel.id)))}
                  onChange={(event, newValue) => {
                    formik.setFieldValue('partnerReligion', newValue.map(item => String(item.id)));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Partner Religion"
                      variant="outlined"
                      className='mb-3'
                      error={formik.touched.partnerReligion && Boolean(formik.errors.partnerReligion)}
                      helperText={formik.touched.partnerReligion && formik.errors.partnerReligion}
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={`${option.religion} {${option.domain}}`}  // Add domain in braces for chips
                        onDelete={() => formik.setFieldValue('partnerReligion', formik.values.partnerReligion.filter(id => id !== String(option.id)))}
                        {...getTagProps({ index })}
                        key={option.id}
                      />
                    ))
                  }
                />
              </div>

              <div className="col-md-6">
                <Autocomplete
                  multiple
                  options={communities}
                  getOptionLabel={(option) => `${option.caste} (${option.religion})`}  // Added religion in parentheses
                  value={communities.filter(caste => formik.values.partnerCaste.includes(String(caste.id)))}
                  onChange={(event, newValue) => {
                    formik.setFieldValue('partnerCaste', newValue.map(item => String(item.id)));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Partner Caste"
                      variant="outlined"
                      className='mb-3'
                      error={formik.touched.partnerCaste && Boolean(formik.errors.partnerCaste)}
                      helperText={formik.touched.partnerCaste && formik.errors.partnerCaste}
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={`${option.caste} (${option.religion})`}  // Added religion in parentheses
                        onDelete={() => formik.setFieldValue('partnerCaste', formik.values.partnerCaste.filter(id => id !== String(option.id)))}
                        {...getTagProps({ index })}
                        key={option.id}
                      />
                    ))
                  }
                />
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Sevvai Dosham"
                  variant="outlined"
                  className="mb-3"
                  name="partnerSevvaiDosham"
                  value={formik.values.partnerSevvaiDosham}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.partnerSevvaiDosham && Boolean(formik.errors.partnerSevvaiDosham)}
                  helperText={formik.touched.partnerSevvaiDosham && formik.errors.partnerSevvaiDosham}
                >
                  <MenuItem value="">Select Sevvai Dosham</MenuItem>
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                  <MenuItem value="Doesn't Matter">Doesn't Matter</MenuItem>
                </TextField>
              </div>

              <div className="col-md-6">
                <Autocomplete
                  multiple
                  options={languages}
                  getOptionLabel={(option) => option.language}
                  value={languages.filter(rel => formik.values.partnerMotherTongue.includes(String(rel.id)))}
                  onChange={(event, newValue) => {
                    formik.setFieldValue('partnerMotherTongue', newValue.map(item => String(item.id)));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Partner Mother tongue"
                      variant="outlined"
                      className='mb-3'
                      error={formik.touched.partnerMotherTongue && Boolean(formik.errors.partnerMotherTongue)}
                      helperText={formik.touched.partnerMotherTongue && formik.errors.partnerMotherTongue}
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={option?.language || ''} // Safeguard against undefined option
                        onDelete={() =>
                          formik.setFieldValue('partnerMotherTongue', formik.values.partnerMotherTongue.filter(id => id !== String(option.id)))
                        }
                        {...getTagProps({ index })}
                        key={option.id}
                      />
                    ))
                  }
                />
              </div>
            </div>
            <div className="col-md-6"></div>
            {/* <div className="d-grid col-4 mx-auto mt-2"> */}
            <Button type="submit" variant="contained" sx={{ backgroundColor: '#FF8008' }}>
              {formik.isSubmitting ? 'Saving...' : 'Save Changes'}
            </Button>
            {/* </div> */}

          </form>
        </CardContent>
      </Card>
    </div>
  )
}
